export default {
  COLLECTIONS: 1,
  CLUSTERS: 2,
  FEEDBACK: 3,
};



// WEBPACK FOOTER //
// ./src/modules/FAQ/_data/learningState.js